<template>
  <ValidationObserver ref="validator">
    <form novalidate class="md-layout generic-form" @submit.prevent="validate">
      <div class="md-layout-item md-medium-size-100 md-size-100">
        <md-card>
          <md-card-content>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-25 md-small-size-100">
                <ValidationProvider name="table name" rules="required" v-slot="{ passed, failed, errors }" slim>
                  <md-field :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]">
                    <label>Table Name</label>
                    <md-select v-model="forwardDto.table_name">
                      <md-option :value="'availability_action_current'">{{ 'Availability Action Current' }}</md-option>
                      <md-option :value="'mlos_action_current'">{{ 'Mlos Action Current' }}</md-option>
                      <md-option :value="'price_action_current'">{{ 'Price Action Current' }}</md-option>
                      <md-option :value="'restriction_action_current'">{{ 'Restriction Action Current' }}</md-option>
                    </md-select>
                    <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
                  </md-field>
                </ValidationProvider>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-100">
                <room-type-select multiple v-model="forwardDto.room_type_ids"></room-type-select>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-100">
                <channel-select multiple v-model="forwardDto.channel_ids" :online="true"></channel-select>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-100">
                <board-select multiple v-model="forwardDto.board_ids"></board-select>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-100">
                <rate-select multiple v-model="forwardDto.rate_ids"></rate-select>
              </div>
              <div class="md-layout-item md-size-30 md-small-size-100">
                <date-range-picker
                  :start="forwardDto.travel_from"
                  :end="forwardDto.travel_to"
                  @change="changeTravelDate"
                  :min-days="1"
                  :max-days="maxDays"
                  :max-months="3"
                  :displayList="false"
                  :displayFrom="false"
                  :displayTo="false"
                  displayFromTo
                  style="min-width: 250px;"
                />
              </div>
            </div>
          </md-card-content>

          <md-card-actions>
            <md-button class="md-success" type="submit">Save</md-button>
          </md-card-actions>
        </md-card>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import DateRangePicker from '@/components/Inputs/DateRangePicker.vue'
import RoomTypeSelect from '@/components/Inputs/RoomTypeSelect.vue'
import BoardSelect from '@/components/Inputs/BoardSelect.vue'
import ChannelSelect from '@/components/Inputs/ChannelSelect.vue'
import RateSelect from '@/components/Inputs/RateSelect.vue'

import { ForwardsApi } from '@/openapi/src'

const forwardsApi = new ForwardsApi()

export default {
  name: 'ForwardsActions',
  components: {
    DateRangePicker,
    RoomTypeSelect,
    RateSelect,
    BoardSelect,
    ChannelSelect,
  },
  data() {
    return {
      forwardDto: {
        tenant_name: null,
        hotel_id: null,
        table_name: null,
        travel_from: null,
        travel_to: null,
        room_type_ids: [],
        board_ids: [],
        channel_ids: [],
        rate_ids: [],
      },
      maxDays: 10,
    }
  },
  methods: {
    changeTravelDate(range) {
      this.forwardDto.travel_from = range.start
      this.forwardDto.travel_to = range.end
    },
    markForwardsAction() {
      this.forwardDto.hotel_id = sessionStorage.getItem('hotel')
      this.forwardDto.tenant_name = this.getTenantName()

      forwardsApi.forwardsActions(this.forwardDto, (error, data) => {})

      this.$notify({
        timeout: 4500,
        message: 'The Actions was saved shortly',
        icon: 'check_box',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'info',
      })
    },
    getTenantName() {
      return this.$root.tenantName()
    },

    async validate() {
      const isValid = await this.$refs.validator.validate()
      if (isValid) {
        return this.markForwardsAction()
      }
    },
  },
}
</script>
<style lang="scss">
@import 'src/assets/scss/md/_variables.scss';

.range {
  & .from,
  .to {
    & input {
      min-height: 0px;
    }
  }
}
</style>
